// Small portal bridge; does not import the game engine into the initial bundle.
const sessions = new Set();
export const isGameActive = () => sessions.size > 0;

export function beginGameActivity() {
  const id = Symbol('game');
  sessions.add(id);
  window.dispatchEvent(new Event('aorra:game-activity'));
  return () => {
    if (sessions.delete(id)) window.dispatchEvent(new Event('aorra:game-activity'));
  };
}
